import React, { useEffect, useState } from 'react';
import './DataDetailsFolder.css';
import { MdKeyboardBackspace } from 'react-icons/md';
import { Button, Select, Table } from 'antd';
import { MdOutlineDelete } from 'react-icons/md';
import { IoMdAdd } from 'react-icons/io';
import { IoDocuments } from 'react-icons/io5';
import CreateSupportDocument from '../../../../Build/From/CreateSupportDocument/CreateSupportDocument';
import { useParams } from 'react-router-dom';
import { workspaces_Support_Documents_Data_Details_List_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesDataDetails';
import { workspaces_Support_Documents_Edit_Data_Details_ActionHandler } from '../../../../../Redux/Actions/user/workspacesSupportDocumentsEditDataDetails';
import { useDispatch, useSelector } from 'react-redux';
import EditSupportDocument from '../../../../Build/From/EditSupportDocument/EditSupportDocument/EditSupportDocument';
import EditWebsiteUrlSupportDocument from '../../../../Build/From/EditSupportDocument/EditWebsiteUrlSupportDocument/EditWebsiteUrlSupportDocument';
import EditOwnDataSupportDocument from '../../../../Build/From/EditSupportDocument/EditOwnDataSupportDocument/EditOwnDataSupportDocument';
import Swal from 'sweetalert2';
import { SupportingDocumentDeleteHandler } from '../../../../../Redux/Actions/user/SupportingDocumentsDelete';
const SearchIcon = '/assets/SearchIcon.svg';
const editIcon = '/assets/editPencil.svg';
let { Option } = Select;
const DataDetailsFolder = ({
    setDatadetalisid,
    setworkspacefoldername,
    handleClickBack,
}) => {
    let dispatch = useDispatch();
    const parms = useParams();
    const workspace_id = parms.id;
    const [searchValue, setSearchValue] = useState(null);
    const [isCreateSupportDocument, setIsCreateSupportDocument] =
        useState(false);
    const [isEditReferData, setIsEditReferData] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [isOwnDataEditReferData, setIsOwnDataEditReferData] = useState(false);
    const [isUrlEditReferData, setIsUrlEditReferData] = useState(false);
    const [isFileType, setIsFileType] = useState(null);
    const [editSupportData, setEditSupportData] = useState([]);
    const [DragDropFile, setDragDropFile] = useState('');
    const [isDragging, setIsDragging] = useState(false);
    const [isUploadComputer, setIsUploadComputer] = useState(false);
    const workspaceDataDetailsData = useSelector(
        (state) =>
            state?.workspaces_Data_Details_Data?.workspace_data_details_data
                ?.data
    );
    const workspaceSupportDocumentsEditData = useSelector(
        (state) =>
            state?.WorkspaceSupportDocumentsEditData
                ?.workspace_support_documents_edit_data?.data
    );
    useEffect(() => {
        const intervalId = setInterval(() => {
            dispatch(
                workspaces_Support_Documents_Data_Details_List_ActionHandler(
                    workspace_id,
                    setDatadetalisid,
                    '',
                    '',
                    currentPage
                )
            );
        }, 1000000);
        return () => clearInterval(intervalId);
    }, [workspaceDataDetailsData]); //
    const columns = [
        { title: 'Name', dataIndex: 'name', key: 'name' },
        {
            title: 'Created By',
            dataIndex: 'created_by',
            key: 'created_by',
            render: (text, record) => <>{record.created_by.first_name}</>,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (text, record) => (
                <div key={`data-folder-${record.id}`}>
                    {record.type === 'url'
                        ? 'URL'
                        : record.type.charAt(0).toUpperCase() +
                          record.type.slice(1)}
                </div>
            ),
        },
        { title: 'File Size', dataIndex: 'file_size', key: 'file_size' },
        {
            title: 'Status',
            dataIndex: 'indexing_status',
            key: 'indexing_status',
        },
        {
            title: 'Edit',
            dataIndex: '',
            key: 'x',
            render: (text, record) => (
                <div
                    className='cursor_pointer'
                    onClick={() => handleEditClick(record.id, record.type)}>
                    {record.indexing_status !== 'PENDING' ? (
                        <img src={editIcon} alt='' />
                    ) : (
                        ''
                    )}
                </div>
            ),
        },
        {
            title: 'Delete',
            dataIndex: '',
            key: 'x',
            render: (text, record) => (
                <MdOutlineDelete
                    className='DeleteIcon'
                    onClick={() => handleDeleteRole(record.id)}
                />
            ),
        },
    ];
    const handleDeleteRole = (id) => {
        if (id) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'You are about to delete a supporting document.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it',
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        position: 'centre',
                        icon: 'success',
                        title: 'Supporting Documents has been deleted successfully',
                        showConfirmButton: false,
                        timer: 1000,
                    });
                    dispatch(SupportingDocumentDeleteHandler(id));
                    setTimeout(() => {
                        dispatch(
                            workspaces_Support_Documents_Data_Details_List_ActionHandler(
                                workspace_id,
                                setDatadetalisid,
                                '',
                                '',
                                currentPage
                            )
                        );
                    }, 1000);
                }
            });
        }
    };
    //drag and drop
    const handleDragEnter = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        setIsUploadComputer(true);
        // setIsUploadOutComputer(true);
        // setRunStatusMainData("");
        const files = e.dataTransfer.files;

        setDragDropFile(files);
    };
    const handleEditClick = (Id, type) => {
        setIsEditReferData(false);
        setIsUrlEditReferData(false);
        setIsOwnDataEditReferData(false);
        setIsFileType(type);
        if (Id && type) {
            dispatch(
                workspaces_Support_Documents_Edit_Data_Details_ActionHandler(Id)
            );
        }
        dispatch(
            workspaces_Support_Documents_Data_Details_List_ActionHandler(
                workspace_id,
                setDatadetalisid,
                '',
                '',
                currentPage
            )
        );
    };
    const handleCreateSupportDocument = () => {
        dispatch(
            workspaces_Support_Documents_Data_Details_List_ActionHandler(
                workspace_id,
                setDatadetalisid
            )
        );
        setIsCreateSupportDocument(!isCreateSupportDocument);
    };
    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const handleSearch = debounce((e) => {
        let value = e.target.value;
        let encodedValue = encodeURIComponent(value);
        if (encodedValue?.length) {
            setSearchValue(encodedValue);
        }
        if (!encodedValue.length) {
            dispatch(
                workspaces_Support_Documents_Data_Details_List_ActionHandler(
                    workspace_id,
                    setDatadetalisid,
                    '',
                    '',
                    currentPage
                )
            );
        }
    }, 1000);
    useEffect(() => {
        if (searchValue?.length > 3) {
            dispatch(
                workspaces_Support_Documents_Data_Details_List_ActionHandler(
                    workspace_id,
                    setDatadetalisid,
                    searchValue,
                    '',
                    currentPage
                )
            );
        }
    }, [searchValue]);
    useEffect(() => {
        if (workspace_id && setDatadetalisid) {
            dispatch(
                workspaces_Support_Documents_Data_Details_List_ActionHandler(
                    workspace_id,
                    setDatadetalisid,
                    '',
                    '',
                    currentPage
                )
            );
        }
    }, [workspace_id, setDatadetalisid]);
    const handleSortChange = (sortvalue) => {
        dispatch(
            workspaces_Support_Documents_Data_Details_List_ActionHandler(
                workspace_id,
                setDatadetalisid,
                '',
                sortvalue,
                currentPage
            )
        );
    };
    useEffect(() => {
        if (workspaceSupportDocumentsEditData) {
            setEditSupportData(workspaceSupportDocumentsEditData);
            if (isFileType === 'file') {
                setIsEditReferData(!isEditReferData);
            }
            if (isFileType === 'url') {
                setIsUrlEditReferData(!isUrlEditReferData);
            }
            if (isFileType === 'text') {
                setIsOwnDataEditReferData(!isOwnDataEditReferData);
            }
        }
    }, [workspaceSupportDocumentsEditData]);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(
            workspaces_Support_Documents_Data_Details_List_ActionHandler(
                workspace_id,
                setDatadetalisid,
                '',
                '',
                page
            )
        );
    };
    return (
        <div className='workspace-container'>
            <div className='data-details-folder-main-1'>
                <p>
                    <IoDocuments />
                    Supporting Documents ({workspaceDataDetailsData?.total || 0}
                    )
                </p>
                <div>
                    <h4
                        className='cursor'
                        onClick={() => handleClickBack(false)}>
                        <MdKeyboardBackspace />
                        Back to Folder
                    </h4>
                    <Button
                        className='main-api float-left'
                        onClick={handleCreateSupportDocument}>
                        <IoMdAdd />
                        Add Files
                    </Button>
                </div>
            </div>
            <div className='brand-text'>{setworkspacefoldername}</div>
            <div className='data-details-folder-main-2'>
                <div className='relative search-container'>
                    <input
                        created_by='text'
                        placeholder='Search Documents here...'
                        className='search-from-logs'
                        onChange={(e) => handleSearch(e)}
                    />
                    <img src={SearchIcon} alt='' className='search-icon' />
                </div>
                <div>
                    <Select
                        defaultValue='Sort By'
                        className='workspace-select-class-div'
                        onChange={handleSortChange}>
                        <Option value='name'> Name</Option>
                        <Option value='created_at'> Created At</Option>
                    </Select>
                </div>
            </div>
            <div className='data-details-folder-main-3'>
                <Table
                    columns={columns}
                    dataSource={workspaceDataDetailsData?.data}
                    bordered
                    size='middle'
                    // pagination={{
                    //     pageSize: workspaceDataDetailsData?.per_page,
                    // }}
                    pagination={{
                        pageSize: workspaceDataDetailsData?.per_page,
                        total: workspaceDataDetailsData?.total,
                        showSizeChanger: false,
                        onChange: handlePageChange,
                    }}
                    className='mytable'
                />
            </div>
            {isCreateSupportDocument ? (
                <CreateSupportDocument
                    isCreateSupportDocument={isCreateSupportDocument}
                    handleCreateSupportDocument={handleCreateSupportDocument}
                    workspaceFolderFlag={true}
                    workspace_id={workspace_id}
                    folder_id={setDatadetalisid}
                />
            ) : null}
            {isEditReferData ? (
                <EditSupportDocument
                    isEditReferData={isEditReferData}
                    handleEditClick={handleEditClick}
                    editSupportData={editSupportData}
                    workspace_id={workspace_id}
                    folder_id={setDatadetalisid}
                    workspaceFolderFlag={true}
                    DragDropFile={DragDropFile}
                    setDragDropFile={setDragDropFile}
                />
            ) : null}
            {isUrlEditReferData ? (
                <EditWebsiteUrlSupportDocument
                    isUrlEditReferData={isUrlEditReferData}
                    handleEditClick={handleEditClick}
                    editSupportData={editSupportData}
                    workspace_id={workspace_id}
                    folder_id={setDatadetalisid}
                    workspaceFolderFlag={true}
                />
            ) : null}
            {isOwnDataEditReferData ? (
                <EditOwnDataSupportDocument
                    isOwnDataEditReferData={isOwnDataEditReferData}
                    handleEditClick={handleEditClick}
                    editSupportData={editSupportData}
                    workspace_id={workspace_id}
                    folder_id={setDatadetalisid}
                    workspaceFolderFlag={true}
                />
            ) : null}
        </div>
    );
};
export default DataDetailsFolder;
